import { render } from "./AppUpdateNotification.vue?vue&type=template&id=ba8f33fc&scoped=true"
import script from "./AppUpdateNotification.vue?vue&type=script&lang=js"
export * from "./AppUpdateNotification.vue?vue&type=script&lang=js"

import "./AppUpdateNotification.vue?vue&type=style&index=0&id=ba8f33fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8f33fc"]])

export default __exports__